const TableMultiSelectionFilter = (rows, columnIds, filterValue) => {
	const val = rows.getValue(columnIds);

	return filterValue?.includes(val);
};

TableMultiSelectionFilter.autoRemove = (val) => val === undefined || val === null || val === '';

export default TableMultiSelectionFilter;
